import { useState } from 'react';

/**
 * useDynamicDensity manages the stepped density scale values based on measured overflows.
 * Density steps: comfortable (0) -> standard (1) -> compact (2).
 */
export function useDynamicDensity() {
  const [densityMode, setDensityMode] = useState('comfortable'); // comfortable | standard | compact
  
  const stepDownDensity = (currentMode) => {
    if (currentMode === 'comfortable') {
      setDensityMode('standard');
      return 'standard';
    }
    if (currentMode === 'standard') {
      setDensityMode('compact');
      return 'compact';
    }
    return 'compact'; // already compact
  };

  const resetDensity = () => {
    setDensityMode('comfortable');
  };

  const getDensityVariables = (mode) => {
    switch (mode) {
      case 'compact':
        return {
          '--font-size-display': '20pt',
          '--font-size-heading': '9pt',
          '--font-size-subheading': '8.5pt',
          '--font-size-body': '8pt',
          '--font-size-meta': '7pt',
          '--font-size-caption': '6.5pt',
          '--font-size-label': '7pt',
          
          '--spacing-margin': '12px',
          '--spacing-element-gap': '8px',
          '--spacing-paragraph-gap': '4px',
          '--spacing-bullet-gap': '3px',
          '--spacing-section-mb': '12px',
          '--spacing-item-mb': '6px',
        };
      case 'comfortable':
        return {
          '--font-size-display': '24pt',
          '--font-size-heading': '11pt',
          '--font-size-subheading': '9.5pt',
          '--font-size-body': '9pt',
          '--font-size-meta': '8pt',
          '--font-size-caption': '7.5pt',
          '--font-size-label': '8pt',
          
          '--spacing-margin': '24px',
          '--spacing-element-gap': '16px',
          '--spacing-paragraph-gap': '8px',
          '--spacing-bullet-gap': '6px',
          '--spacing-section-mb': '22px',
          '--spacing-item-mb': '12px',
        };
      case 'standard':
      default:
        return {
          '--font-size-display': '22pt',
          '--font-size-heading': '10pt',
          '--font-size-subheading': '9pt',
          '--font-size-body': '8.5pt',
          '--font-size-meta': '7.5pt',
          '--font-size-caption': '7pt',
          '--font-size-label': '7.5pt',
          
          '--spacing-margin': '18px',
          '--spacing-element-gap': '12px',
          '--spacing-paragraph-gap': '6px',
          '--spacing-bullet-gap': '4px',
          '--spacing-section-mb': '16px',
          '--spacing-item-mb': '8px',
        };
    }
  };

  return {
    densityMode,
    stepDownDensity,
    resetDensity,
    getDensityVariables: () => getDensityVariables(densityMode)
  };
}
